export enum TableColumns {
  isbn = "ISBN",
  author = "Author",
  title = "Title",
  productGroupDescription = "Product form",
  publishedAt = "Last Published",
}

export enum SearchSuggestionType {
  BOOKS_QUICK = "books_quick",
  BOOKS_SEMANTIC = "books_semantic",
  THEMA_QUICK = "thema_quick",
  BISAC_QUICK = "bisac_quick",
}

export interface SearchSuggestion {
  title: string;
  value: string;
  hoverText: string;
  type: SearchSuggestionType;
}

export interface SearchSuggestionListItem {
  title: string;
  items: SearchSuggestion[];
}
